var React = require('react');

function CheckWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI / Check"},React.createElement("path",{"id":"Vector 1","d":"M1.125 8.4375L6.1875 13.5L16.875 3.375","stroke":"#FFFFFF","strokeWidth":"3"})));
}

CheckWhite.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CheckWhite;

CheckWhite.default = CheckWhite;
